// src/vocabulary/B2/unit4/content.js

const content = {
  level: "B2",
  unit: 4,
  title: "Opinions & Decisions",
  description:
    "Vocabulary used to express opinions, agree or disagree, and make decisions in everyday situations.",

  explanation: [
    "This unit focuses on expressing opinions and making decisions.",
    "You will learn words and phrases used to say what you think.",
    "People often use these words in discussions and conversations.",
    "You can agree or disagree politely using these expressions.",
    "For example: I think this is a good idea. In my opinion, it is too expensive.",
    "You can also talk about decisions you make in daily life.",
    "This vocabulary helps you speak more clearly and confidently.",
    "Try to give your opinion and explain your decision."
  ],

  items: [
    {
      word: "opinion",
      phonetic: "/əˈpɪnjən/",
      meaning: "رأي",
      example: "In my opinion, this plan is good."
    },
    {
      word: "decision",
      phonetic: "/dɪˈsɪʒn/",
      meaning: "قرار",
      example: "I made an important decision."
    },
    {
      word: "agree",
      phonetic: "/əˈɡriː/",
      meaning: "يوافق",
      example: "I agree with you."
    },
    {
      word: "disagree",
      phonetic: "/ˌdɪsəˈɡriː/",
      meaning: "يعارض",
      example: "I disagree with this idea."
    },
    {
      word: "choice",
      phonetic: "/tʃɔɪs/",
      meaning: "اختيار",
      example: "We have a difficult choice."
    },
    {
      word: "decide",
      phonetic: "/dɪˈsaɪd/",
      meaning: "يقرر",
      example: "She decided to change her job."
    }
  ]
};

export default content;


